import type { RouteObject } from 'react-router-dom'
import ErrorBoundary from '@/components/ErrorBoundary'
import Home from '@/pages/Home'
import { useRoutes } from 'react-router-dom'

// 僅供 prerender 與公開首頁使用，不載入後台模組
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
]

function App() {
  const element = useRoutes(routes)

  return (
    <ErrorBoundary>
      {element}
    </ErrorBoundary>
  )
}

export default App
